import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const menuItemStyle = css`
  width: 100%;
`;

export const iconLeftSpacing = css`
  margin-left: auto;
`;

export const listboxStyle = css`
  height: 240px;
`;

export const popoverStyle = css`
  border-radius: ${theme.borderRadius.medium};
  box-shadow: ${theme.shadows.floating};
  border: 1px solid ${theme.colors.neutral10};
  width: 300px;
`;

export const listboxOptionStyle = css`
  border-radius: ${theme.borderRadius.small};
  padding: ${theme.spacing(1)};
  align-items: center;

  span {
    display: flex;
    gap: ${theme.spacing(1)};
  }
`;
